app.controller("CalendarEventAddController", [
    "$scope", "CalendarEventsService", "$state", "$uibModal", "toastr", "StaticData",
    function ($scope, CalendarEventsService, $state, $uibModal, toastr, StaticData) {
        $scope.dt=new Date();
        $scope.mytime = new Date();
        $scope.hstep = 1;
        $scope.mstep = 10;
        $scope.time = new Date(
            $scope.dt.getFullYear(),
            $scope.dt.getMonth(),
            $scope.dt.getDate(),
            $scope.mytime.getHours(),
            $scope.mytime.getMinutes()
        );
        $scope.faculties = null;
        $scope.title = "";
        $scope.description = null;
        $scope.faculty = "";

        StaticData.getItemsByKey("faculties").then(function (faculties) {
            $scope.faculties = [{name: "ფაკულტეტი"}].concat(faculties);
        });

        $scope.add = function () {
            CalendarEventsService.add({
                faculties: $scope.faculty,
                title: $scope.title,
                description: $scope.description,
                time: $scope.time
            }).then(function () {
                toastr.success('', 'ღონისძიება დამატებულია');
                $state.go('admin.calendar-events')
            }).catch(function () {
                toastr.error('', 'ღონისძიების დამატებისას დაფიქსირდა შეცდომა');
            })
        };
    }
])
;